import axios from 'axios'

import { createMessage } from '../actions'

export const SET_ROLES = 'SET_ROLES'

export function setRoles({ es_role = 'admin', search = null, callback, limit, offset }) {
  return (dispatch, getState) => {
    const orgId = getState()
      .get('engagement')
      .orgs.get('company').id
    const token = getState()
      .get('engagement')
      .auth.get('JWT')

    let searchQuery = ''

    if (search) searchQuery = `&search=${search}`

    const queryParams = `${searchQuery}&es_role=${es_role}&limit=${limit}&offset=${offset}`

    return axios({
      method: 'get',
      url: `/employees/?organization=${orgId}&is_active=true&ordering=first_name&exclude_internal_admins=true${queryParams}`,

      headers: {
        Authorization: token
      }
    })
      .then(res => {
        dispatch({
          type: SET_ROLES,
          key: es_role,
          data: res.data
        })
        if (callback && typeof callback === 'function') callback(true)
      })
      .catch(err => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not retrieve roles.'
            },
            8000
          )
        )
        if (callback && typeof callback === 'function') callback(false)
        // eslint-disable-next-line no-console
        console.error(err)
      })
  }
}

export function updateRole({ data, callback, isNewRole, isRemoveRole }) {
  return (dispatch, getState) => {
    const token = getState()
      .get('engagement')
      .auth.get('JWT')

    return axios({
      method: 'post',
      url: `/roles/`,

      headers: {
        Authorization: token
      },
      data
    })
      .then(() => {
        if (callback && typeof callback === 'function') callback(true)
        let content = 'Role has been updated!'
        if (isNewRole) content = 'New roles assigned!'
        if (isRemoveRole) content = 'Role has been deleted!'

        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'success',
              header: 'Success:',
              content
            },
            8000,
            true
          )
        )
      })
      .catch(err => {
        dispatch(
          createMessage(
            {
              type: 'generic',
              level: 'danger',
              header: 'Error:',
              content: 'Could not update role.'
            },
            8000
          )
        )
        if (callback && typeof callback === 'function') callback(false)
        // eslint-disable-next-line no-console
        console.error(err)
      })
  }
}
